<template>
  <div class="controls">
    <div class="content ibox-content">
      <div class="row">
        <div class="col-md-4">
          <div class="actions">
            <button class="btn btn-primary"
              @click="handleOnClickEndedShoe"
              v-show="shoeIsOpen"
              :disabled="gameIsOpen">จบขอน</button>
            <button class="btn btn-primary"
              @click="handleOnClickBeginShoe"
              v-show="!shoeIsOpen"
              :disabled="gameIsOpen">เริ่มขอนใหม่</button>
            <button class="btn btn-danger"
              @click="handleOnClickEndedGame"
              :disabled="!gameIsOpen">ปิดเกมส์ฉุกเฉิน</button>
            <button class="btn btn-default"
              @click="handleOnClickRandomCard"
              v-shortkey="['f1']" @shortkey="shortKeyRandomCard"
              :disabled="!gameIsOpen || insurance">สุ่มออกไพ่</button>
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox"
                v-model="allowMemberBetting"
                v-shortkey="['f2']" @shortkey="shortKeyBeginGameWithDisallowBet">
                อนุญาตให้ผู้เล่นวางเดิมพัน
            </label>
          </div>
        </div>
        <div class="col-md-4 text-center">
          <span class="timer badge clock">{{ remaining | number('00') }}</span>
        </div>
        <div class="col-md-4 text-right">
          <div class="actions">
            <button class="btn btn-primary"
              @click="handleOnClickBeginGame"
              v-shortkey="['f4']" @shortkey="shortKeyBeginGameWithAllowBet"
              :disabled="!shoeIsOpen || gameIsOpen">เริ่มเกมส์ใหม่</button>
          </div>
          <div class="checkbox">
            <label>
              <input type="checkbox"
              v-shortkey="['f3']" @shortkey="shortKeyOpenCardModal"
              v-model="showModalCard"
              :disabled="!gameIsOpen"> ออกไพ่แบบไม่มีการแสกน
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="table-responsive">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>โต๊ะที่</th>
                    <th>เกมส์</th>
                    <th>ขอนที่</th>
                    <th>รอบที่</th>
                    <th>ออนไลน์</th>
                    <th>ฝั่งผู้เล่น</th>
                    <th>ฝั่งเจ้ามือ</th>
                    <th>อื่นๆ</th>
                    <th>เดิมพันรอบนี้</th>
                  </tr>
                </thead>
                <tbody v-if="game">
                  <tr>
                    <td>{{ game.table_id }}</td>
                    <td>{{ game.game_title }}</td>
                    <td>{{ game.shoe_id }}</td>
                    <td>{{ game.round }}</td>
                    <td>{{ members.count }}</td>
                    <td>{{ betsOnPlayer | number }}</td>
                    <td>{{ betsOnBanker | number }}</td>
                    <td>{{ betsOnOthers | number }}</td>
                    <td>{{ bets.total | number }}</td>
                  </tr>
                </tbody>
              </table>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.ibox-content -->
        </div> <!-- /.ibox -->
      </div> <!-- /.col-lg-12 -->
    </div> <!-- /.row -->
    <div class="content cards">
      <div class="row">
        <div class="col-md-6" v-for="who in ['player', 'banker']">
          <div class="ibox-content cards-place">
            <div class="row">
              <div class="col-md-6 text-left signs">
                <template v-if="results">
                  <span class="winner" v-show="theWinnerIs(who)">
                    <i class="fa fa-thumbs-o-up"></i>
                  </span>
                  <span class="loser" v-show="!theWinnerIs(who)">
                    <i class="fa fa-thumbs-o-down"></i>
                  </span>
                </template>
                <span class="handup" v-show="theNextTurnIs(who)">
                  <i class="fa fa-hand-paper-o"></i>
                </span>
              </div>
              <div class="col-md-6 text-right">
                <h1>
                  {{ who | uppercase }}
                  <span class="badge badge-info">{{ competitor[who].score }}</span>
                </h1>
              </div>
            </div>
            <div class="m-b-sm text-center">
              <template v-for="card in competitor[who].cards">
                <img :src="'/assets/cards/'+ card +'.png'" class="img-responsive">
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ibox-content guide">
      <div class="row">
        <ul class="signs">
          <li>
            <i class="winner fa fa-thumbs-o-up"></i>
            ฝ่ายชนะ
          </li>
          <li>
            <i class="loser fa fa-thumbs-o-down"></i>
            ฝ่ายแพ้
          </li>
          <li>
            <i class="handup fa fa-hand-paper-o"></i>
            ฝั่งที่ต้องการ ไพ่เพิ่ม
          </li>
        </ul>
      </div>
      <div class="row">
        <ul class="shortkeys">
          <li>กด 7 เพื่อเริ่มเกมส์แบบ ไม่อนุญาตให้วางเดิมพัน</li>
          <li>กด 0 เพื่อเริ่มเกมส์แบบ อนุญาตให้วางเดิมพัน</li>
          <li>กด f3 เพื่อใช้งานการออกไพ่ ไม่ผ่านการแสกน</li>
          <li>กด o เพื่อทำการสุ่มออกไพ่</li>
        </ul>
      </div>
    </div>

    <baccaratInsurance :insurance="insurance" :onTimeup="handleInsuranceTimeup"></baccaratInsurance>
    <scanner :onCodeReceive="handleCodeReceive"></scanner>

    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title" id="myModalLabel">{{ message.title }}</h4>
          </div>
          <div class="modal-body">
            <div class="alert"
              :class="{
                'alert-info': message.type === 'info',
                'alert-danger': message.type === 'error',
                'alert-success': message.type === 'success'
              }">
              {{ message.body }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal suites fade" id="myModalCards" tabindex="-1" role="dialog" aria-labelledby="myModalCardslLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <template v-for="(suit, index) in suits">
              <span class="card" v-for="card in suit">
                <img :src="'/assets/cards/'+ card+index +'.png'" @click="handleOnClickDealingCard(card+index)">
              </span>
            </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  let tickCountdown
  import Scanner from './Scanner'
  import BaccaratInsurance from './BaccaratInsurance'
  export default {
    name: 'baccarat',
    components: {
      Scanner,
      BaccaratInsurance
    },
    props: {
      tableId: {
        type: [String, Number],
        required: true
      }
    },
    data () {
      return {
        remaining: 0,
        results: null,
        message: {
          type: 'error',
          code: 0,
          title: 'กรุณาอ่าน',
          body: '....',
          timeInMs: null
        },
        game: {},
        deal: {},
        bets: {},
        members: {},
        competitor: {
          player: {
            cards: [],
            score: 0
          },
          banker: {
            cards: [],
            score: 0
          }
        },
        shoeIsOpen: false,
        gameIsOpen: false,
        allowMemberBetting: true,
        showModalCard: false,
        suits: {
          'D': ['A', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'J', 'Q', 'K'],
          'C': ['A', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'J', 'Q', 'K'],
          'H': ['A', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'J', 'Q', 'K'],
          'S': ['A', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'J', 'Q', 'K']
        },
        decks: [],
        insurance: null
      }
    },
    mounted () {
      // Shuffle the cards into decks,
      // this is just for development.
      this.shuffleDeckOfCards()

      // Subscribe to baccarat table channel.
      const tableId = this.tableId
      const channel = pusher.subscribe('baccarat.'+ tableId)

      // Binding to get who is online.
      channel.bind('pusher:subscription_succeeded', (members) => {
        this.members = members
      })

      // Every members bet a game.
      channel.bind('bets', (data) => {
        this.bets = data
      })

      // Receive new card from scanner by agent.
      channel.bind('receive_card', (data) => {
        this.handleOnClickDealingCard(data.card)
      })

      // Receive on the same time as users.
      channel.bind('deal', (data) => {
        this.deal = data
        // In case insurance.
        if (_.result(this.deal, 'insurance.id')) {
          this.insurance = this.deal.insurance
        }
      })

      channel.bind('result', (data) => {
        this.results = data
        this.gameIsOpen = false
        $('#myModalCards').modal('hide')
      })

      // Get current game.
      this.getCurrentGame()

      // Close modal cards event.
      $('#myModalCards').on('hidden.bs.modal', () => {
        this.showModalCard = false
      })
    },
    computed: {
      betsOnPlayer () {
        return _.get(this.bets, 'type.PLAYER.sum', 0)
      },
      betsOnBanker () {
        return _.get(this.bets, 'type.BANKER.sum', 0)
      },
      betsOnOthers () {
        if (this.bets.type === undefined) return 0
        const total = _.chain(this.bets.type)
          .omit(['PLAYER', 'BANKER'])
          .map(v => parseInt(v.sum))
          .sum()
          .value()
        return total
      }
    },
    methods: {
      handleOnClickBeginShoe () {
        axios.post('/baccarat/'+ this.tableId +'/startshoe')
          .then(resp => {
            this.shoeIsOpen = true
          })
          .catch(e => {
            if (!e.response) {
              console.log('Error on start game:', e)
              return
            }
            const errorResponse = e.response.data
            this.showMessage('error', errorResponse.error)
          })
      },
      handleOnClickEndedShoe () {
        axios.post('/baccarat/'+ this.tableId +'/endshoe')
          .then(resp => {
            this.shoeIsOpen = false
          })
          .catch(e => {
            if (!e.response) {
              console.log('Error on end shoe:', e)
              return
            }
            const errorResponse = e.response.data
            this.showMessage('error', errorResponse.error)
          })
      },
      handleOnClickBeginGame () {
        // this.showMessage('success', 'eeeee')
        const allowMemberBetting = this.allowMemberBetting ? 1 : 0
        axios.post('/baccarat', { table_id: this.tableId, betting: allowMemberBetting })
          .then(resp => {
            this.game = resp.data
            this.deal = {}
            this.bets = {}
            this.results = null
            this.insurance = null
            this.gameIsOpen = true
          })
          .catch(e => {
            if (!e.response) {
              console.log('Error on start game:', e)
              return
            }
            const errorResponse = e.response.data
            if (errorResponse.code === 'game_not_over') {
              this.showMessage('error', 'เกมส์ยังไม่จบไม่สามารถเริ่มใหม่ได้')
            } else {
              this.showMessage('error', errorResponse.error)
            }
          })
      },
      handleOnClickEndedGame () {
        axios.post('/baccarat/'+ this.tableId +'/forceendgame')
          .then(resp => {
            this.gameIsOpen = false
          })
          .catch(e => {
            if (!e.response) {
              console.log('Error on end game:', e)
              return
            }
            const errorResponse = e.response.data
            this.showMessage('error', errorResponse.error)
          })
      },
      shuffleDeckOfCards () {
        let cards = []
        let suits = _.cloneDeep(this.suits)
        _.forEach(suits, (values, key) => {
          values.map((value) => {
            cards.push(value + key)
          })
        })
        cards = _.concat(cards, cards, cards, cards, cards, cards, cards, cards)
        cards = _.shuffle(_.shuffle(_.shuffle(cards)))
        this.decks = cards
      },
      handleOnClickRandomCard () {
        const first = this.decks.shift()
        this.handleOnClickDealingCard(first)
      },
      handleOnClickDealingCard (card) {
        const gameId = _.get(this.game, 'id')
        if (!gameId) return
        // On dealing insurance.
        if (this.insurance) return

        let turn = _.get(this.deal, 'turn')
        turn = (turn) ? parseInt(turn) + 1 : 1

        const data = { id: gameId, table_id: this.tableId, card: card, request_id: `${gameId}|${turn}` }
        axios.post('/baccarat/deal', Object.assign({}, data, { status: 'open' }))
          .then(resp => {
            // Auto endgame on testing.
            if (resp.data.status === 'end') {
              setTimeout(() => {
                axios.post('/baccarat/deal', Object.assign({}, data, { status: 'confirmed_endgame', request_id: `${gameId}|end` }))
              }, 5000)
            }
            // Auto insurance on testing.
            if (_.result(resp.data, 'insurance.data.id')) {
              setTimeout(() => {
                axios.post('/baccarat/deal', Object.assign({}, data, { status: 'confirmed_insurance', request_id: `${gameId}|${turn}_insurance` }))
              }, 5000)
            }
          })
          .catch(e => {
            if (!e.response) {
              console.log('Error on del card:', e)
              return
            }
            // Too many requests.
            if (e.response.status === 429) {
              console.log(e.response.data.error)
              return
            }
            const errorResponse = e.response.data
            this.showMessage('error', errorResponse.error)
          })
      },
      handleInsuranceTimeup () {
        this.insurance = null
      },
      theWinnerIs (compare) {
        return _.eq(compare.toUpperCase(), _.get(this.results, 'winner'))
      },
      theNextTurnIs (compare) {
        return _.eq(compare, _.get(this.deal, 'current.who_next_deal'))
      },
      getCurrentGame () {
        // Get the current game here.
        axios.get('/baccarat/'+ this.tableId +'/current')
          .then(resp => {
            const { game, deal, bets } = resp.data
            this.shoeIsOpen = true
            this.gameIsOpen = true
            this.game = game
            this.deal = deal
            this.bets = bets
          })
          .catch(e => {
            if (!e.response) {
              console.log('Error on getCurrent:', e)
              return
            }
            const errorResponse = e.response.data
            // Shoe is not open yet!
            if (errorResponse.code === 'shoe_not_open') {
              this.shoeIsOpen = false
            }
            // Shoe still open, but no game yet!
            if (errorResponse.code === 'no_game_to_play') {
              this.shoeIsOpen = true
            }
          })
      },
      startCountdown () {
        if (this.remaining == 0) return
        clearInterval(tickCountdown)
        tickCountdown = setInterval(() => {
          this.remaining--
          if (this.remaining <= 0) {
            this.onTimeElapsed()
            clearInterval(tickCountdown)
          }
        }, 1000)
      },
      onTimeElapsed () {
        this.showMessage('info', 'ดีลเลอร์ทำการ แจกไพ่ได้', 1500)
      },
      showMessage (type, body, timeClose = 3000) {
        this.message = Object.assign(this.message, {
          type: type,
          body: body,
          timeInMs: Date.now()
        })

        setTimeout(() => {
          $('#myModal').modal('hide')
        }, timeClose)
      },
      shortKeyBeginGameWithAllowBet () {
        this.allowMemberBetting = 1
        this.handleOnClickBeginGame()
      },
      shortKeyBeginGameWithDisallowBet () {
        this.allowMemberBetting = 0
        this.handleOnClickBeginGame()
      },
      shortKeyOpenCardModal (card, index) {
        if (!this.gameIsOpen) return
        this.showModalCard = true
      },
      shortKeyRandomCard () {
        if (!this.gameIsOpen) return
        this.handleOnClickRandomCard()
      },
      handleCodeReceive (code) {
        if (/^[0-9AJQK][DHCS]/.test(code)) {
          console.log('Pass on scanned')
          const scannedCode = _.trim(code)
          this.handleOnClickDealingCard(scannedCode)
        }
      }
    },
    watch: {
      message: {
        handler: function (value, old) {
          $('#myModal').modal('show')
        },
        deep: true
      },
      showModalCard: {
        handler: function (value, old) {
          if (value === true) {
            $('#myModalCards').modal('show')
          }
        }
      },
      game: {
        handler: function (value, old) {
          if (value === null) return
          this.remaining = value.remaining
          this.startCountdown()
        },
        deep: true
      },
      deal: {
        handler: function (value, old) {
          this.competitor = {
            player: {
              cards: _.get(value, 'histories.p.card', []),
              score: parseInt(_.get(value, 'score.hands.p', 0))
            },
            banker: {
              cards: _.get(value, 'histories.b.card', []),
              score: parseInt(_.get(value, 'score.hands.b', 0))
            }
          }
        },
        deep: true
      },
      decks: {
        handler: function(value, old) {
          if (value.length === 30) {
            this.shuffleDeckOfCards()
          }
        }
      }
    },
    filters: {
      uppercase: function (value) {
        return value.toUpperCase()
      }
    }
  }
</script>
<style>
  .controls .modal-body .alert {
    margin: 0;
  }
  .controls .modal.suites .modal-body .card img {
    width: 63px;
    margin: 0 5px 5px 0;
    cursor: pointer;
  }
  .controls .modal.suites .modal-dialog {
    width: 1006px;
    margin: 30px auto;
  }
  .controls .badge {
    font-size: 25px;
  }
  .controls .cards {
    margin: 0 0;
  }
  .controls .cards .cards-place {
    min-height: 240px;
  }
  .controls .cards img {
    display: inline;
    margin: 0 2px;
    max-width: 100px;
  }
  .controls .timer {
    font-size: 4em;
  }
  .controls .cards .signs {
    font-size: 40px;
  }
  .controls .signs .handup {
    color: cornflowerblue;
  }
  .controls .signs .winner {
    color: mediumseagreen;
  }
  .controls .signs .loser {
    color: tomato;
  }
  .controls .guide {
    margin-top: 20px;
  }
  .controls .guide ul.signs {
    list-style-type: none;
    padding: 0 0;
    margin: 0 10px;
  }
  .controls .guide ul.signs li {
    display: inline;
    padding-right: 20px;
  }
  .controls .guide ul.shortkeys {
    margin-top: 20px
  }
  .controls .guide ul.shortkeys li {
    line-height: 2em
  }
  .controls .clock {
    background-color:#000;
    color:#F8E81C;
    padding:15px;
    text-shadow: 2px 2px 0 rgba(0,0,0,.26);
    border-radius: 40px;
    font-size:40px
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/dealer/Baccarat.vue